/**
 * Sends a GA4 page_view event on every react-router route change.
 *
 * The base GA4 snippet in index.html is configured with `send_page_view: false`
 * so this hook is the single source of truth for page_view firing in this SPA.
 *
 * No-op if gtag isn't available (e.g. ad-blocker or analytics disabled).
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useAnalyticsPageView = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    // GA4
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
    // Microsoft Clarity — explicit hint for SPA route changes
    if (typeof window.clarity === 'function') {
      try { window.clarity('set', 'page_path', path); } catch (e) { /* noop */ }
    }
  }, [location.pathname, location.search]);
};

export default useAnalyticsPageView;
